import React, { Component } from 'react';
import styled from 'styled-components';
import { system } from './system';
import Checkbox from './Checkbox';
import Label from './Label';

// Replicated from molekule/lib/Form/RadioGroup.js
// Props: choices (array of {value, label, disabled}), name, label, value,
//        onChange(name, value), horizontal, colorOn, colorOff, size, error

interface RadioGroupSys {
  [key: string]: any;
}

const GroupContainer = styled.div<{
  $horizontal?: boolean;
  $sys?: RadioGroupSys;
}>`
  ${(p: { $horizontal?: boolean }) =>
    p.$horizontal
      ? `
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
      `
      : `
        display: flex;
        flex-direction: column;
      `}

  ${(p: any) => system(p.$sys, p.theme)}
`;

const FormError = styled.span`
  display: block;
  color: ${(p: any) =>
    p.theme && p.theme.colors
      ? p.theme.colors.red || p.theme.colors.danger
      : '#FD575D'};
  font-size: 12px;
  margin-top: 4px;
`;

export interface RadioChoice {
  value?: string | number;
  id?: string | number;
  label?: string;
  disabled?: boolean;
}

export interface RadioGroupProps {
  name?: string;
  label?: string;
  value?: string | number | null;
  choices?: RadioChoice[];
  onChange?: (name: string, value: any) => void;
  horizontal?: boolean;
  colorOn?: string;
  colorOff?: string;
  size?: string;
  error?: string;
  styles?: Record<string, any>;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

interface RadioGroupState {
  value: string | number | null;
}

class RadioGroup extends Component<RadioGroupProps, RadioGroupState> {
  static defaultProps = {
    choices: [],
    onChange: () => {},
    styles: {},
    horizontal: false,
    colorOn: 'primary',
    colorOff: 'greyDark',
  };

  constructor(props: RadioGroupProps) {
    super(props);
    this.state = {
      value: props.value != null ? props.value : null,
    };
  }

  static getDerivedStateFromProps(
    props: RadioGroupProps,
    state: RadioGroupState,
  ) {
    if (props.value !== undefined && props.value !== state.value) {
      return { value: props.value };
    }
    return null;
  }

  handleChange = (field: string, value: any) => {
    if (this.state.value === value) return;
    this.setState({ value }, () => {
      if (this.props.onChange && this.props.name) {
        this.props.onChange(this.props.name, value);
      }
    });
  };

  render() {
    const {
      name,
      label,
      choices,
      error,
      horizontal,
      colorOn,
      colorOff,
      size,
      className,
      style,
    } = this.props;

    const { value } = this.state;

    return (
      <div className={className} style={style}>
        {label && <Label>{label}</Label>}
        <GroupContainer $horizontal={horizontal}>
          {(choices || []).map((choice) => {
            const choiceValue = choice.value != null ? choice.value : choice.id;
            const key = `RadioButton-${name}-${choiceValue}`;
            return (
              <Checkbox
                key={key}
                id={key}
                name={key}
                horizontal={horizontal}
                label={choice.label}
                value={value}
                valueTrue={choiceValue}
                valueFalse={null}
                onChange={this.handleChange}
                isRadio={true}
                colorOn={colorOn}
                colorOff={colorOff}
                size={size}
                disabled={choice.disabled}
              />
            );
          })}
        </GroupContainer>
        {!!error && <FormError>{error}</FormError>}
      </div>
    );
  }
}

export default RadioGroup;
